const setVideosList = data => ({
    type: "SET_VIDEOS_LIST",
    data
  });

  export const mutation = {
    setVideosList
  };
